import { Paper, Stack } from '@mui/material';
import { ReactNode } from 'react';
import { ChartTooltipActions } from './ChartTooltipActions';

interface ChartTooltipContentProps {
  renderHeader?: () => ReactNode;
}

export function ChartTooltipContent({
  renderHeader,
}: ChartTooltipContentProps) {
  return (
    <Stack
      component={Paper}
      elevation={8}
      spacing={1}
      sx={{
        width: 300,
        borderRadius: 2,
      }}
    >
      {renderHeader?.()}
      <ChartTooltipActions />
    </Stack>
  );
}
